/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_A1dInputs */

const en_mk_sol_agensi_a1d = /** @type {(inputs: Mk_Sol_Agensi_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts captions and content calendars, matches each client’s voice, and queues for approval before anything goes live.`)
};

const id_mk_sol_agensi_a1d = /** @type {(inputs: Mk_Sol_Agensi_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun caption dan kalender konten, meniru nada tiap klien, lalu mengantre approval sebelum ada yang tayang.`)
};

/**
* | output |
* | --- |
* | "Drafts captions and content calendars, matches each client’s voice, and queues for approval before anything goes live." |
*
* @param {Mk_Sol_Agensi_A1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_a1d = /** @type {((inputs?: Mk_Sol_Agensi_A1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_A1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_a1d(inputs)
	return en_mk_sol_agensi_a1d(inputs)
});